<template>

    <el-row id="pcmenu">


        <el-col :span="8" style="height:auto;background: white;width: 400px">
            <el-row type="flex" justify="center" style="height: auto">
                <el-col :span="24">
                    <el-col :span="24" style="text-align: end;">
                        <span style="font-size: 19px;float: left;line-height: 30px;font-weight: bold">功能菜单列表[手机端]</span>
                        <el-button type="success" icon="el-icon-plus" style="background: #4EC880" size="small"
                                   @click="open3">新增菜单项</el-button>
                    </el-col>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="height: auto">
                <el-col :span="24" style="border: 1px solid #eee;height: auto">
                    <div style="padding: 10px">
                        <el-input
                                class="sWei"
                                placeholder="请输入功能菜单名称进行快速检索"
                                v-model="filterText">
                        </el-input>
                    </div>
                    <!--:class="$style.scrollbar"-->
                    <el-scrollbar style="height: 500px">

                        <el-tree
                                class="filter-tree"
                                :data="data"
                                @node-click="handleNodeClick"
                                :props="defaultProps"
                                node-key="menu_id"
                                :highlight-current="true"
                                :filter-node-method="filterNode"
                                :default-expanded-keys="[1000,2000]"
                                ref="tree">
                            <apan></apan>
                        </el-tree>
                    </el-scrollbar>

                </el-col>
            </el-row>
        </el-col>
        <el-col :span="16" class="StoCen" style="height: auto">
            <el-row style="height: 20px;margin-top: 4px" type="flex" align="middle">
                <el-col :span="3" style="font-size: 17px;font-weight: bold">功能菜单</el-col>
                <el-col :span="12" style="color: #409EFF;font-size: 17px;font-weight: bold">{{menu_name}}</el-col>
                <el-col :span="3" :push="6" >
                    <el-button type="text" :disabled="addUserDis" @click="upOpen" :style="{color:
                    updataActive?'#F8A929':'#eee',float:'right'}" style="font-size: 17px;" id="el-button">编辑
                    </el-button>
                </el-col>

            </el-row>
            <el-row class="xux"></el-row>
            <!--            <el-row v-for="(item,index) in valueArr" :key="index" style="font-size: 12px;height: auto">-->
            <!--            说明{{index+1}}:{{item}}-->
            <!--        </el-row>-->
            <el-row>
                <el-col :span="18">
                    <el-form style="margin-left: 20px" ref="form" :model="tableData" label-width="180px" v-if="dec"
                             :label-position="left" id="el-form">

                        <el-form-item label="菜单名称">
                            <p v-text="tableData.menu_name" style="margin: 0;color: #3b99f7;"></p>
                        </el-form-item>
                        <el-form-item label="上级菜单">
                            <p v-text="tableData.parent_menu" style="margin: 0;">{{tableData.parent_menu}}</p>
                        </el-form-item>
                        <el-form-item label="功能程序">
                            <p v-text="tableData.menu_type" style="margin: 0;"></p>
                        </el-form-item>
                        <el-form-item label="页面URL">
                            <p v-text="tableData.url" style="margin: 0;"></p>
                        </el-form-item>
                        <el-form-item label="菜单图标">
                            <p v-text="tableData.icon" style="margin: 0;"></p>
                        </el-form-item>
                        <el-form-item label="图标URL">
                            <p v-text="tableData.icon_url" style="margin: 0;"></p>
                        </el-form-item>
                        <el-form-item label="隐藏">
                            <el-switch
                                    style="margin: 0"
                                    v-model="tableData.hiddenBool"
                                    active-color="#13ce66"
                                    disabled>
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="仅开发可见">
                            <el-switch
                                    style="margin: 0"
                                    v-model="tableData.devBool"
                                    active-color="#13ce66"
                                    disabled>
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="仅测试可见">
                            <el-switch
                                    style="margin: 0"
                                    v-model="tableData.testBool"
                                    active-color="#13ce66"
                                    disabled>
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="系统内置">
                            <el-switch
                                    style="margin: 0"
                                    v-model="tableData.builtinBool"
                                    active-color="#13ce66"
                                    disabled>
                            </el-switch>
                        </el-form-item>

                    </el-form>
                </el-col>

                <!--                <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">选项总数：{{tableData.length}}个</el-col>-->
                <el-col :span="6" style="text-align: end;float: right" >
                    <!--                    <el-button type="warning" size="small" @click="dialogFormVisibleValue=true"-->
                    <!--                               :disabled="!updataActive" >设定参数值</el-button>-->
                </el-col>
            </el-row>

        </el-col>

        <!--新增系统列表-->
        <el-dialog title="" :visible.sync="dialogFormVisible" id="addpcmenu">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">新增自定义菜单</span>
                <span>
                <el-button @click="addlist('new')" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish()" size="small">取消</el-button>
                </span>

            </div>
            <el-row style="height: auto;width: 90%;margin: auto">
                <el-form :model="addpcmenu" label-width="120px">
                    <el-form-item label="菜单名称">
                        <el-input v-model="addpcmenu.menu_name" ></el-input>
                    </el-form-item>
                    <el-form-item label="上级菜单">
                        <el-input v-model="addpcmenu.parent_menu"></el-input>
                    </el-form-item>
                    <el-form-item label="功能程序">
                        <el-input v-model="addpcmenu.menu_type" ></el-input>
                    </el-form-item>
                    <el-form-item label="页面URL">
                        <el-input v-model="addpcmenu.url"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单图标">
                        <el-input v-model="addpcmenu.icon"></el-input>
                    </el-form-item>
                    <el-form-item label="图标URL">
                        <el-input v-model="addpcmenu.icon_url"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏">
                        <el-switch
                                v-model="addHidden"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="仅开发可见">
                        <el-switch
                                v-model="addDev"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="仅测试可见">
                        <el-switch
                                v-model="addTest"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                </el-form>
            </el-row>
        </el-dialog>
        <!--编辑系统列表-->
        <el-dialog title="" :visible.sync="dialogFormVisibleup">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 20px">编辑自定义菜单</span>
                <span>
                <el-button @click="addlist('editor')" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish()" size="small">取消</el-button>
                </span>
            </div>
            <el-row style="height: auto">
                <el-form :model="parameters" label-width="120px">
                    <el-form-item label="菜单名称">
                        <el-input v-model="parameters.menu_name" ></el-input>
                    </el-form-item>
                    <el-form-item label="上级菜单">
                        <el-input v-model="parameters.parent_menu"></el-input>
                    </el-form-item>
                    <el-form-item label="功能程序">
                        <el-input v-model="parameters.menu_type" ></el-input>
                    </el-form-item>
                    <el-form-item label="页面URL">
                        <el-input v-model="parameters.url"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单图标">
                        <el-input v-model="parameters.icon"></el-input>
                    </el-form-item>
                    <el-form-item label="图标URL">
                        <el-input v-model="parameters.icon_url"></el-input>
                    </el-form-item>
                    <el-form-item label="隐藏">
                        <el-switch
                                v-model="hidden"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="仅开发可见">
                        <el-switch
                                v-model="dev"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="仅测试可见">
                        <el-switch
                                v-model="test"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                </el-form>
            </el-row>
        </el-dialog >
    </el-row>
</template>

<script>
    import http from '../../../APIService/http'
    import { MessageBox, Message } from 'element-ui';
    let number=1
    export default {
        name: "Main",
        data() {
            return {
                onOff:true,
                hidden:true,
                dev:true,
                test:true,
                addHidden:false,
                addDev:false,
                addTest:false,
                addBuiltin:false,
                addpcmenu:{},
                left:'left',
                dialogFormVisibleValue:false,
                addUserDis:true,
                parameters:{},
                options: [],
                input_type:'',
                options2:[{
                    value: 'TEXT',
                    label: '文本'
                },{
                    value: 'NUMBER',
                    label: '数值'
                },{
                    value: 'COMMENTS',
                    label: '段落'
                },{
                    value: 'TRUE-FALSE',
                    label: '开关'
                },{
                    value: 'LIST',
                    label: '下拉列表'
                },{
                    value: 'DATE',
                    label: '时间'
                }],
                myonOff:'',
                inputType:'',
                parameter_id:'',
                defData:{},
                updataActive:'',
                dialogFormVisible3:false,
                dialogFormVisible:false,
                dialogFormVisibleup:false,
                treeKey:"",
                dec:false,
                //表格数据
                tableData: [],
                filterText: '',
                data: [],
                defaultProps: {
                    label: 'label'
                },
                menu_name:''
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        created () {
            this.getLibrary();
        },

        methods: {

            addlist(type) {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(type == 'new'){    //新增
                        if (!this.addpcmenu.menu_name) {
                            Message({
                                type: 'error',
                                message: '菜单名称不能为空'
                            });
                        } else if (!this.addpcmenu.menu_type) {
                            Message({
                                type: 'error',
                                message: '功能程序不能为空'
                            });
                        } else if (!this.addpcmenu.url) {
                            Message({
                                type: 'error',
                                message: '页面URL不能为空'
                            });
                        }
                        // else if (!this.addpcmenu.icon) {
                        //     Message({
                        //         type: 'error',
                        //         message: '菜单图标不能为空'
                        //     });
                        // } else if (!this.addpcmenu.icon_url) {
                        //     Message({
                        //         type: 'error',
                        //         message: '图标URL不能为空'
                        //     });
                        // }
                        let user = this.$store.getters.getUser
                        let data ={

                        }
                        http.post('/wapi/parameters/addPcmenuDefinitionList',data).then(res=>{
                            if(res.success){

                            }else{

                            }
                        })




                    }else{ //编辑
                        if (!this.parameters.menu_name) {
                            Message({
                                type: 'error',
                                message: '菜单名称不能为空'
                            });
                        } else if (!this.parameters.menu_type) {
                            Message({
                                type: 'error',
                                message: '功能程序不能为空'
                            });
                        } else if (!this.parameters.url) {
                            Message({
                                type: 'error',
                                message: '页面URL不能为空'
                            });
                        }
                        // else if (!this.parameters.icon) {
                        //     Message({
                        //         type: 'error',
                        //         message: '菜单图标不能为空'
                        //     });
                        // } else if (!this.parameters.icon_url) {
                        //     Message({
                        //         type: 'error',
                        //         message: '图标URL不能为空'
                        //     });
                        // }
                        let user = this.$store.getters.getUser
                        let data ={

                        }
                        http.post('',data).then(res=>{
                            if(res.success){

                            }else{

                            }
                        })



                    }
                }catch (e) {
                    loading.close()
                    return e
                }



            },

            async getLibrary() {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id
                    }
                    this.data =[{menu_id:1000,label:'系统内置',children:[]},{label:'自定义',children:[],menu_id:2000}]
                    await http.post('/wapi/parameters/getPcmenuDefinitionList', data).then(res => {
                        // setTimeout(() => { this.$refs.tree.setCurrentKey(this.treeKey)},100)
                        if (res.success) {
                            for (let i=0;i<res.data.length;i++){
                                if (res.data[i].builtin === 'T' ){
                                    this.data[0].children.push(res.data[i])
                                } else {
                                    this.data[1].children.push(res.data[i])
                                }
                            }
                            console.log(this.data)
                        }
                        loading.close();
                    })

                } catch (err) {
                    loading.close();
                    console.log(`error:${err}`)
                }
            },


            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            //新增菜单项
            open3() {
                this.dialogFormVisible = true
            },
            upOpen() {
                this.parameters.menu_name = this.tableData.menu_name
                this.parameters.parent_menu = this.tableData.parent_menu
                this.parameters.menu_type = this.tableData.menu_type
                this.parameters.url = this.tableData.url
                this.parameters.icon = this.tableData.icon
                this.parameters.icon_url = this.tableData.icon_url
                this.hidden = this.tableData.hiddenBool
                this.dev = this.tableData.devBool
                this.test = this.tableData.testBool
                this.dialogFormVisibleup = true
            },
            abolish() {
                this.dialogFormVisible = false
                this.dialogFormVisibleup = false
                for (let key in this.parameters) {
                    this.parameters[key] = ''
                }

            },

            handleNodeClick(data, node, ele) {
                if (data.label === '系统内置' || data.label === '自定义') {
                    this.addUserDis = true
                    return;
                } else {
                    this.dec = true;
                    this.addUserDis = false
                    this.tableData = data
                    console.log(data, this.tableData, 777)
                    this.menu_name = this.tableData.menu_name
                    this.tableData.parent_menu = data.parent_menu == '' ? '无' : data.parent_menu
                    this.tableData.hiddenBool = data.hidden == 'T' ? true : false
                    this.tableData.builtinBool = data.builtin == 'T' ? true : false
                    this.tableData.devBool = data.dev == 'T' ? true : false
                    this.tableData.testBool = data.test == 'T' ? true : false
                    this.updataActive = true
                    this.defData = data
                    // if (data.status === 'ACTIVE'){
                    //     this.onOff = true
                    // } else {
                    //     this.onOff = false
                    // }
                    // this.getDictionaryList(data)
                    // if (data.input_type == 'LIST') {
                    //     this.getDictionary_definitionList()
                    // }
                    //禁用状态
                    // this.updataActive = true
                    // this.myonOff = data.input_type
                    //
                    // if (data.input_type === 'NUMBER') {
                    //     this.inputType = 'number'
                    // } else if (data.input_type === 'TEXT') {
                    //     this.inputType = 'text'
                    // } else if (data.input_type === 'COMMENTS') {
                    //     this.inputType = 'textarea'
                    // }
                }
            }

        }
    };
</script>

<style>
    /*限制文字长度*/
    #pcmenu .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
    #pcmenu .el-tree-node__content span{
        max-width: 240px;

        overflow: hidden;
        margin-left: 10px;
        color: #bbbbbb;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
    }
    #pcmenu .el-tree-node__expand-icon{
        display: none;
    }
    #pcmenu .el-tree-node__content{
        /*display: flex;*/
        /*justify-content: space-between;*/
        height: 40px;
    }
    #pcmenu .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content:before{
        content: "";
        display: inline-block;
        background: url("../../../assets/images/phoneTree.png") no-repeat;
        background-size:16px ;
        width: 16px;
        height: 16px;
        margin: 20px;
    }
    #pcmenu .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content span{
        margin-left: 0;
        font-size: 16px;
        max-width: 240px;

        overflow: hidden;
        color: #606266;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /*输入框背景*/
    #pcmenu .sWei .el-input__inner{
        background: #eee;
    }
    #pcmenu .StoCen{
        background: white;
        height: auto;
        padding: 0 15px;
    }
    /*.el-main{
      padding: 0;
    }*/
    #pcmenu{
        display: flex;
        justify-content: center;
        height: auto;
    }
    #pcmenu .StoW .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
    }
    #pcmenu .el-row {
        margin-bottom: 12px;
        height: 30px;
    }
    #pcmenu .xux {
        border-bottom: 2px dashed #eee;
        height: 10px;
    }
    #pcmenu .butC {
        padding: 8px 10px;
        margin-top: 26px;
    }
    #pcmenu .tally {
        border: 2px solid rgb(29, 170, 252);
        height: 100%;
        width: 110px;
        margin: 0 10px;
        padding: 0 5px;
        color: rgb(29, 170, 252);
    }
    #pcmenu .tally:nth-of-type(2) {
        border-color: rgb(30, 255, 79);
        color: rgb(30, 255, 79);
    }
    #pcmenu .tally:nth-of-type(3) {
        border-color: rgb(255, 203, 30);
        color: rgb(255, 203, 30);
    }
    #pcmenu .tally:nth-of-type(4) {
        border-color: rgb(255, 30, 244);
        color: rgb(255, 30, 244);
    }
    #pcmenu .tallyBox {
        height: 60px;
        display: flex;
        margin-bottom: 10px;
        justify-content: flex-end;
    }
    #pcmenu .tally .el-row {
        margin: 0;
        font-size: 12px;
        height: 25px;
    }
    #pcmenu .tally .el-row:nth-of-type(2) {
        text-align: center;
        font-size: 20px;
    }
    #pcmenu .cell{
        text-align: left;
    }
    #pcmenu .el-dialog__header {
        border-bottom: 2px dashed #DCDFE6;
        padding: 20px 0 20px 0;
        margin: 20px 20px 10px;
    }
    #pcmenu .el-dialog__close{
        display: none;
    }
    #pcmenu .el-dialog__body{
        padding-right:100px ;
    }
    #pcmenu .el-form-item__label{
        color: black;
        font-size: 16px;
    }
    .dialog-footer {
        margin-top: 10px;
    }
    #el-button span{
        font-weight: bold;
    }
    #el-form .el-form-item{
        margin-bottom: 10px;
    }
    #elFromValue .el-input{
        width: 80%;
    }
    #pcmenuValue .el-dialog__body{
        padding: 20px 20px 20px 30px;
    }
    #addpcmenu .el-input__inner{
        width: 80%;
    }
    #addpcmenu .el-dialog__body{
        padding: 20px 20px 20px 30px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/develop/components/pcmenu.vue